<template>
  <div class="imdiv">
    <div v-if="!$store.state.stopPreviews" v-on:click.stop="zoom">
      <template v-if="isGif">
        <square-gif-viewer :src="mediaPath" />
      </template>
      <template v-if="hasPreviewClip && isHovered">
        <square-clip-viewer :src="previewClipUrl" />
      </template>
    </div>
    
    <img :src="imageUrl" :alt="image.alt" class="anim-main" v-on:click="zoom" />

    <div class="greybar" :class="{viewable: isHovered}" v-show="loaded">
        <div>
          <div class="a-name">
            {{ artist.formatted_name }}
          </div>
          <div>
            <small-button v-on:click="zoom">{{ $nippets.play }}</small-button>
          </div>
        </div>
        <div class="likebox-holder low"><like-box :imageId="image.image_id" /></div>
    </div>
  </div>
</template>

<script>
import SquareGifViewer from '@/components/widgets/SquareGifViewer.vue'
import SquareClipViewer from '@/components/widgets/SquareClipViewer.vue'
import LikeBox from '@/components/buttons/LikeBox.vue'
import MesaurablePage from '@/mixins/MeasurablePage.js'

export default {
  components:{
    SquareGifViewer,
    SquareClipViewer,
    LikeBox
  },
  props: {
    image: Object,
    artist: Object
  },
  mixins: [ MesaurablePage ],
  data () {
    return {
      hasPreviewClip: false,
      mediaPath: '',
      previewClipUrl: '',
      isGif: false,
      loaded: true,
      isHovered: false,
      ctr: 0
    }
  },
  computed: {
    imageUrl: function () {
      if(this.mwidth < 1024) {
        return this.$k.getImageCrop500(this.image.url)
      }
      return this.$k.getImageCrop700(this.image.url)
    }
  },
  created () {
    this.setup()
  },
  mounted () {
    this.$el.addEventListener('mouseenter', this.setHoveredTrue)
    this.$el.addEventListener('mouseleave', this.setHoveredFalse)
  },
  beforeDestroy () {
    this.$el.removeEventListener('mouseenter', this.setHoveredTrue)
    this.$el.removeEventListener('mouseleave', this.setHoveredFalse)
  },
  methods: {
    setHoveredTrue () {
      this.isHovered = true
    },
    setHoveredFalse () {
      this.isHovered = false
    },
    zoom: function () {
      this.$emit('zoom', this.image)
    },
    setup: async function () {
      if(this.artist){
        if(this.image){
          const ext = this.$k.getExtension(this.image.swf)
          this.isGif = (ext === 'gif')
          if(this.isGif) {
            this.mediaPath = this.$k.imagebase + 'media/artist/' + this.artist.portfolio_url + '/' + this.image.swf
          }
          else {
            this.hasPreviewClip = this.$k.canHaveClip(this.image.swf)
            this.previewClipUrl = this.$k.getPreviewClipUrl(this.image, this.artist)
          }
        }
      }
    }
  },
  watch: {
    image () {
      this.setup()
    }
  }
  
}
</script>


<style scoped>
img.anim-main{
  width:100%;
}

.imdiv{
  overflow:hidden;
  position:relative;
}

.greybar{
  opacity:0;
  transition:all 0.2s ease;
  bottom:-50px;
}

.greybar.viewable{
  opacity:1;
  bottom:0;
}

</style>